<!--
 * @Author: wangshunming 13882054494@163.com
 * @Date: 2025-12-11 14:54:38
 * @LastEditors: wangshunming 13882054494@163.com
 * @LastEditTime: 2025-12-12 15:00:54
 * @FilePath: \tx-web\gitee\erabbit-client-pc-vue-project-master\src\views\category\components\goods-item.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <RouterLink :to="`/product/${goods.id}`" class='goods-item'>
     <img :src="goods.picture" alt="">
      <p class="name ellipsis">{{goods.name}}</p>
    <p class="desc ellipsis">{{goods.tag}}</p>
    <p class="price">&yen;{{goods.price}}</p>
  </RouterLink>
</template>

<script>
export default {
  name: 'GoodsItem',
  props: {
    goods: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style scoped lang='less'>
.goods-item {
  display: block;
  width: 220px;
  padding: 20px 30px;
  text-align: center;
  .hoverShadow();
  img {
    width: 160px;
    height: 160px;
  }
  p {
    padding-top: 10px;
  }
  .name {
    font-size: 16px;
  }
  .desc {
    color: #999;
    height: 29px;
  }
  .price {
    color: @priceColor;
    font-size: 20px;
  }
}
</style>
